import { Icon, InputAdornment, TextField } from "@material-ui/core";
import React, { useState } from "react";
import NumberFormat from "react-number-format";

const CustomNumberFormat = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      value={props.value}
      name={props.name}
      onBlur={props.onBlur}
      prefix={"R$"}
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      isNumericString={true}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

export default ({ field, handleBlur, ...props }) => {
  const [state, setState] = useState(field.value || "");

  const handleChange = (e) => setState(e.target.value);

  return (
    <TextField
      disabled={field.is_basic}
      label={field.label}
      onChange={handleChange}
      onBlur={handleBlur}
      value={state}
      variant="outlined"
      inputProps={{
        fieldid: field.id,
      }}
      InputProps={{
        endAdornment: field.updating ? (
          <InputAdornment position="end" className="p-12">
            <Icon className="fas fa-sync fa-spin m-color-blue" />
          </InputAdornment>
        ) : field.icon ? (
          <InputAdornment position="end" className="p-12">
            <Icon className={field.icon} />
          </InputAdornment>
        ) : null,
        inputComponent: CustomNumberFormat,
      }}
      {...props}
    />
  );
};
